/* Componente mappa */
import React, { Component } from 'react'
import { memo } from "react";
import { Map, TileLayer, ScaleControl , ZoomControl } from 'react-leaflet'
import Location from './Location/LocationComponent'
import MiniMappa from './MiniMap/MiniMapComponent'
import Coordinate from './Show_Coordinate/CoordinateController'
import DrawerPath from '../Calcolo_percorso/DrawerPath/DrawerPath'
import DrawerToc from '../TOC/DrawerTOC/DrawerToc'
import TariffaToc from '../Calcolo_Tariffa/TariffaToc/TariffaToc'
import AddLayerByZoom from './AddLayerByZoom'
import Polyline from './Polyline/Polyline'
import MyPosition from './LocalizzazioneInBarra/LocalizzazioneInBarra'
import ZoomTicket from './ZoomTicket/ZoomTicket'
import Toc from '../TOC/toc'
import DrawerMarkerClick from './DrawerMarkerClick/DrawerMarkerClick'
import DrawMarker from './DrawMarker/DrawMarker'
import MarkerError from './MarkerError/MarkerError'
import AddLayerFile from './AddLayerFile/AddLayerFile'
import VisualizzaAttributi from '../TabellaAttributi/VisualizzaAttributi'
import ClickOnMap from './ClickOnMap/ClickOnMap'
import Percorso from './ClickOnMap/Percorso'
import FirstPath from './FirstPath/FirstPath'
import AddLayer from '../AddLayer/DrawerAddLayer'
import AddLayerUrl from './AddLayerUrl/AddLayerUrl'
import Query from '../QueryComponent/QueryDrawer'
import Stampa from './Stampa/Stampa'
import ZoomSardegna from './ZoomSardegna/ZoomSardegna'
import QueryLayer from './Query/Query'
import DrawerLayer from './ClickOnMap/DrawerLayer'
import LogoSardegna from './logo-sardegna-mobilita-nero.svg'
import Sardegna from './regione-autonoma-sardegna.svg'
//import LogoRegionale from './logo_mobimart-payoff-colore-ITA.jpg'
import LogoRegionale from './interreg-mobimart-2021.png'
import SelectLanguage from './SelectLanguage'
import axios from 'axios'
import i18n from 'i18next';
import "./styles.css";
import Cookies from 'universal-cookie';
import Cookie from './Cookie'
import ChangeMap from './ChangeMap/ChangeMap';
import store from '../redux/store';
import { FormatColorReset, TrainRounded, TramRounded } from '@material-ui/icons'
import Tooltip from '@material-ui/core/Tooltip';
import CookieConsent,{ getCookieConsentValue } from "react-cookie-consent";
import { useLeaflet } from "react-leaflet";
//import ReactGA from 'react-ga'

 class Mappa extends Component {
  constructor(props) {
    super(props);
      this.state = {
      data: null,
      open : false,
      error:false,
      language: 1,
      userId: 0
    
  }
}
async select(){
  
  var qs = require('qs');
  try {
    var id = qs.parse(window.location.search, { ignoreQueryPrefix: true }).id_profile
    if(id !== undefined) {
      let buff = new Buffer(id, 'base64');
      let profile = buff.toString('ascii');
      const arrayProfile = profile.split(":")
      const value = arrayProfile[1]    
    
    if (arrayProfile[0] !=="" && arrayProfile[0] !=="0") {
      //await axios.get(process.env.REACT_APP_PRODUZIONE_USER_TRAVELPLANNER)   
        await axios.get(window.configFile.httpProxy.urlUser)         
        .then(response =>{
          if (response.data.data.roles.includes(value)) this.setState({userId:1})
        }).catch(error=>{})
        //.catch(error=>{this.setState({userId:0})}) 
     }
    } else {
        await axios.get(window.configFile.httpProxy.urlUser)         
        .then(response =>{
          if (response.data.data.roles.length>1) this.setState({userId:1})
        }).catch(error=>{})
      }
  } catch (error) {}
}
  async componentDidMount(){
   
    //ReactGA.pageview(window.location.pathname)

    this.setState({language: selectLan()})
    //this.select()     
    /* const script = document.createElement("script");
    script.src = "http://172.29.61.134/etlsharedrupal/loghi/app_header/Header.js";
    script.async = true;
    document.body.appendChild(script); */
                  /*  var configfile = require('../config/config_file.json')
     this.setState({data: configfile})
     window.configFile = configfile  */                               
    
     
    // Chiamata Get al file di configurazione

          
    //await axios.post('/api/v1/routers/sardegna/showFile',{name: "config_file.json"})
    if(!window.configFile){
      await axios.get(process.env.REACT_APP_PRODUZIONE_SHOWFILE,{headers: window.tp_headers})
      .then(response =>{
        if(!window.configFile) window.configFile = response.data   
        //this.setState({data: response.data})  
        this.select()   
        this.forceUpdate();
      })
      .catch(error=>{
          //var configfile = require('config/config_file.json')
          /*fetch(process.env.REACT_APP_DEFAULT_CONFIGFILE).then((response) => response.json()).then((jsonData)=>{
            const configfile = jsonData;*/
          axios.get(process.env.REACT_APP_DEFAULT_CONFIGFILE).then(response =>{
            if(!window.configFile) window.configFile = response.data //configfile  
            //this.setState({data: configfile})
            this.select()   
            this.forceUpdate();
          }).catch((error) => {
            console.log("ERROR: No config file found!")
            this.setState({error:true})})        
        }) 
    } else {
      //this.setState({data: window.configFile})
      this.select()   
    }                                        
  }

  
  render() {
    
    
    const openSite = ()=>{
      /* window.open("http://sardegnamobilita.it") */ //cambiare homepage
      // window.open(this.state.data.redirectUrl) 
      window.location.href = '/'
    }

    if(!window.configFile && !this.state.error){
      return null; 
    }else if(this.state.error){
       return null
    }else {
      /*var qs = require('qs');
      var isFrame = qs.parse(window.location.search, { ignoreQueryPrefix: true }).frame
      if(window.frame) isFrame = true*/

      
      var isFrame = false
      const queryString = window.location.search  
      const urlParams = new URLSearchParams(queryString)
      if(urlParams.has("frame")) isFrame = true
      
      //const position = this.state.data.serviceOnScreen.position //[40.061604, 9.097754]
      var position = window.configFile.serviceOnScreen.position //[40.061604, 9.097754]
      var positionZoom = window.configFile.serviceOnScreen.positionZoom //[40.061604, 9.097754]
      if(positionZoom===undefined) positionZoom = 8
      if(position===undefined) position = [40.061604, 9.097754]

      return (
      <div id="mappa" className="container">
       
         {isFrame? <img id={"LogoSardegna"} src={LogoSardegna} alt="LogoSardegna" className={"LogoSardegnaOnMap"} onClick={openSite}></img>:<div className={"flex-container"}>
          <div className={"flex-item-left"}>
          <img id={"LogoSardegna"} src={LogoSardegna} alt="LogoSardegna" className={"LogoSardegna"} onClick={openSite}></img> 
           </div>
           <div id={"logoRegionale"}>
            <img src={LogoRegionale} alt="LogoRegionale" className={"LogoRegionale"} ></img>
            </div> 
          <div className={"flex-item-right"} id={"lingua"}>
            <SelectLanguage lingua={this.state.language}></SelectLanguage>
          </div>
        </div>}
        <Map center={position} zoom={positionZoom} zoomControl={false} >
          <TileLayer
          attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          url="https://b.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          { hiddenWidget("ScaleControl", this.state.userId) ? <ScaleControl position={'bottomright'} /> : null}
          { hiddenWidget("ZoomControl", this.state.userId) ? <ZoomControl position={'topright'} /> : null} 
          { <ZoomSardegna value= {dataWidget("ZoomSardegna")} center={position} zoom={positionZoom}/> }
          { hiddenWidget("LocationControl", this.state.userId) ? <Location/> : null} 
          { hiddenWidget("MiniMapControl", this.state.userId) ? <MiniMappa/> : null} 
          { hiddenWidget("CoordinateControl", this.state.userId) ? <Coordinate /> : null}
          { hiddenWidget("Print", this.state.userId) ? <Stampa  value= {dataWidget("Print")}/>: null}
    <ZoomTicket/>
    <MyPosition/>
    {/*<ChangeMap/>*/}
   <Polyline /> 
    <AddLayerByZoom service_config={window.configFile} userId={this.state.userId}/> 
    <DrawMarker/>
    
    <DrawerMarkerClick/> 
    {/*<FirstPath search={window.location.search} data={this.state.data}/>*/}
    <Toc />
    <ClickOnMap/> 
    
    <AddLayerFile/>
      <Percorso/>
    <AddLayerUrl/>
    <QueryLayer/>
    
  </Map>
  <DrawerLayer/> 
        { hiddenWidget("TableOfContent", this.state.userId) ? <DrawerToc value= {dataWidget("TableOfContent")}/> : null} 
        <DrawerPath  value= {dataWidget("CalcoloPercorso")} search={window.location.search} httpProxy={window.configFile.httpProxy}/>
        {/* { hiddenWidget("CalcoloPercorso", this.state.userId) ?<DrawerPath  value= {dataWidget("CalcoloPercorso")} /> : null} */}
        { hiddenWidget("AddLayer", this.state.userId) ?<AddLayer value= {dataWidget("AddLayer")}/>: null}
        { hiddenWidget("Query", this.state.userId) ?<Query  value= {dataWidget("Query")}/>: null}
        {/* {  hiddenWidget("CalcoloTariffa", this.state.userId) ? */}       
        <TariffaToc value= {dataWidget("CalcoloTariffa")}/> {/* : null}   */}   
        {/* { hiddenWidget("Print", this.state.userId) ?<Stampa value= {dataWidget("Print")}/>: null} */}
        { hiddenWidget("Query", this.state.userId) ? <VisualizzaAttributi/>: null}
      
        {/*<Cookie></Cookie>*/}
      </div>
    )
  }
}
 }
 
//Visualizzazione del widget in base all'user ID
  function hiddenWidget(tipoWidget,id){
   var flag  = false//SETTARE A FALSE
   var data=window.configFile
   //var data = this.state.data
   
  
   //DECOMMENTARE PER BUILD
    data.widgetOnScreen.widgets.map(value =>{
    if( value.name === tipoWidget){
      
       flag = value.profileUserId.includes(parseInt(id))
        
      }
      return false    
    })                                                       
        
  

  return flag 
  }

//Recupera le informazioni del widget dal file di configurazione
function dataWidget(tipoWidget){
  var val = ""  
  var data=window.configFile
  //var data = this.state.data
  data.widgetOnScreen.widgets.map(value =>{
    if( value.name === tipoWidget){
        val = value
    }
    return null
  })
  return val
}

function readCookie(name) {
  var c = document.cookie.split('; '),
  cookies = {}, i, C;
  for (i = c.length - 1; i >= 0; i--) {
      C = c[i].split('=');
      cookies[C[0]] = C[1];
   }
   return cookies[name];
}

function getCookie(name) {
  let matches = document.cookie.match(new RegExp(
    "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
  ));
  return matches ? decodeURIComponent(matches[1]) : undefined;
}



//Selezione della lingua
function selectLan (){
 
  var qs = require('qs');
  
    
  //var lan = qs.parse(window.location.search, { ignoreQueryPrefix: true }).id_profile
  
  try {
    //const languageQuery = qs.parse(window.location.search, { ignoreQueryPrefix: true }).language
    var value = readCookie('googtrans') === undefined ? "it" : readCookie('googtrans').split("/")[2]
    


    /* if(languageQuery !== undefined ){
    value = languageQuery
      

    }
    else{
    var lan = qs.parse(window.location.search, { ignoreQueryPrefix: true }).id_profile
    
    lan = lan === undefined ? 'MDphbm9ueW1vdXM6aXQ=' : lan;
    let buff = new Buffer(lan, 'base64');
    let profile = buff.toString('ascii');
    const arrayProfile = profile.split(":")
    value = arrayProfile[arrayProfile.length - 1]
    
    //var value2 = arrayProfile[1]
    
    } */
    
     


    switch (value) {
      case 'en':
        i18n.changeLanguage('en');
        return 0
      case 'it':
        i18n.changeLanguage('it');
        return 1
        case 'fr':
          i18n.changeLanguage('fr');
          return 2 
      default:
       return 1 //cambiare il default
    }
    //chiamata e prendo idprofile, se è anonymous this.setstate(userid:0)else this.setstate(userid:1)
      

  } catch (error) {
    console.log(error)
    return 1
  }


}


//Selezione User ID
//  async function selectUserId(){
//   var qs = require('qs');
//   try {
//     var id = qs.parse(window.location.search, { ignoreQueryPrefix: true }).id_profile
//     let buff = new Buffer(id, 'base64');
//     let profile = buff.toString('ascii');
//     const arrayProfile = profile.split(":")
//     const value = arrayProfile[1]
//     switch (arrayProfile[0]) {
//       case 0:
//         return 0;
//       default:
//          await axios.get("http://sardegnamobilita.it/resources/user-travelplanner")
//         .then(response =>{

//           if (response.data.data.roles.includes(value)){
//               return  arrayProfile[0]
//           } else {
//             return 0
//           }
        
//         })
//         .catch(error=>{})
//     }

//   } catch (error) {

//   }

// }
export default memo(Mappa);